import { Injectable, OnDestroy } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestoreDocument, AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { map, finalize } from 'rxjs/operators';
import { SelectedSchool } from '../enum/selected-school';
import { Parent } from '../models/parents-section.model';
import { SelectSchoolService } from './select-school.service';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { FileUpload } from '../models/file-upload.model';

@Injectable({
  providedIn: 'root'
})
export class ParentsService implements OnDestroy {

  ParentsCollection!: AngularFirestoreCollection<Parent>;
  Parents!: Observable<Parent[]>;
  ParentDoc?: AngularFirestoreDocument<Parent>;
  selectedSchool!: SelectedSchool;
  dbPath!: string;

  constructor(private db: AngularFirestore, 
    private selectSchoolService: SelectSchoolService,
    private storage: AngularFireStorage) { 
  }

  private initializeCollection() {
    this.selectedSchool = this.selectSchoolService.getSchool();
    if (!this.selectedSchool) {
      console.error('No school selected');
      return;
    }
    this.dbPath = 'Parents_' + this.selectedSchool;
    this.ParentsCollection = this.db.collection(`${this.dbPath}/`, ref => ref.orderBy('date','desc'));

    this.Parents = this.ParentsCollection.snapshotChanges().pipe(map((changes: any[]) => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Parent;
        data.id = a.payload.doc.id;
        return data;
      });
    }));
  }

  getAllParents(){
    if (!this.ParentsCollection) {
      this.initializeCollection();
    }
    return this.Parents;
  }

  addParent(parent: Parent){
    if (!this.ParentsCollection) {
      this.initializeCollection();
    }
    console.log('Adding parent to collection:', this.dbPath);
    console.log('Parent data:', parent);
    this.ParentsCollection.add(parent).then(() => {
      console.log('Parent added successfully');
    }).catch((error) => {
      console.error('Error adding parent:', error);
    });
  }

  deleteParent(parent: Parent){
    if (!this.dbPath) {
      this.initializeCollection();
    }
    if(parent.id) {
      this.ParentDoc = this.db.doc(`${this.dbPath}/${parent.id}`);
      this.ParentDoc.delete();
    }
  }

  updateParent(parent: Parent, newParent: Parent){
    if (!this.dbPath) {
      this.initializeCollection();
    }
    if(parent.id) {
      this.ParentDoc = this.db.doc(`${this.dbPath}/${parent.id}`);
      this.ParentDoc.update(newParent);
    }
  }

  pushFileToStorage(fileUpload: FileUpload): Observable<number | undefined> {
    if (!this.dbPath) {
      this.initializeCollection();
    }
    const filePath = `${this.dbPath}/${fileUpload.file.name}`;
    const storageRef = this.storage.ref(filePath);
    const uploadTask = this.storage.upload(filePath, fileUpload.file);

    uploadTask.snapshotChanges().pipe(
      finalize(() => {
        storageRef.getDownloadURL().subscribe(downloadURL => {
          fileUpload.url = downloadURL;
          fileUpload.name = fileUpload.file.name;
        });
      })
    ).subscribe();

    return uploadTask.percentageChanges();
  }

  getFileDownloadURL(fileName: string): Observable<string> {
    const storageRef = this.storage.ref(`${this.dbPath}/${fileName}`);
    return storageRef.getDownloadURL();
  }

  deleteFileStorage(fileName: string): void {
    const storageRef = this.storage.ref(`${this.dbPath}/${fileName}`);
    storageRef.delete();
  }

  ngOnDestroy(): void {
  }

}